
import { GET_CAMPAGNE_ATTIVE_SCREENING_SUCCESS, RESET_PERSISTENT_STORE_STATE, SET_CAMPAGNA } from "./actionsType";

const initialState = {
    campagna: undefined,
    campagneAttiveScreening: undefined,
}

export const persistentStoreReducer = (state = initialState, action) => {
    switch (action.type) {

        case SET_CAMPAGNA:
            return {
                ...state,
                campagna: action.payload
            }
        case GET_CAMPAGNE_ATTIVE_SCREENING_SUCCESS:
            return {
                ...state,
                campagneAttiveScreening: action.payload
            }
        case RESET_PERSISTENT_STORE_STATE:
            return initialState
        case 'persist/REHYDRATE':
            return state;
        default:
            return state
    }
}